import { formatNumberMix } from '@/utils'

export default {
    data() { },
    methods: {
        setTableConfig(data = []) {
            return {
                type: 'table',
                title: '',
                ref: 'table',
                height: '525px',
                cancelShadow: true,
                tableData: data
            }
        }
    }
}
